export const VISIT_STATUS_NAMES: any = {
  sheduled: 'Programada',
  rescheduled: 'Re programada',
  done: 'Finalizada',
  cancelled: 'Cancelada',
  deleted: 'Eliminada',
  pending_approval: 'Pendiente de aprobación',
};

export enum VISIT_STATUS {
  SCHEDULED = 'sheduled',
  RESCHEDULED = 'rescheduled',
  DONE = 'done',
  CANCELLED = 'cancelled',
  DELETED = 'deleted', // for pre sales
  PENDING_APPROVAL = 'pending_approval',
}

export enum VisitPreSaleState {
  PENDING_APPROVAL = 'pending_approval',
  SCHEDULED = 'scheduled',
  RESCHEDULED = 'rescheduled',
  DONE = 'done',
  DELETED = 'deleted',
  VOIDED = 'voided',
}

export type VisitPreSaleStateType = VisitPreSaleState;

export const VISIT_PRE_SALE_STATUS_NAMES: any = {
  pending_approval: 'Pendiente de aprobación',
  scheduled: 'Programada',
  rescheduled: 'Reprogramada',
  done: 'Finalizada',
  deleted: 'Eliminada',
  voided: 'Anulada',
};

export const VISIT_PRE_SALE_STATUS_BADGE_COLOR: any = {
  pending_approval: 'warning',
  scheduled: 'info',
  rescheduled: 'warning',
  done: 'success',
  deleted: 'danger',
  voided: 'danger',
};

export const VISIT_STATUS_BADGE_COLOR: any = {
  pending_approval: 'warning',
  sheduled: 'info',
  rescheduled: 'warning',
  done: 'success',
  deleted: 'danger',
  cancelled: 'danger',
};

// Advisory leads (user-service). `pending_approval`/`scheduled`/`cancelled`
// reusan el mismo texto/color que ya tienen VISIT_STATUS_NAMES/
// VISIT_PRE_SALE_STATUS_NAMES para esos mismos valores — mismo significado.
// No incluye `rejected`: existe en el enum del backend sólo por
// compatibilidad de tipos, reject() fue retirado y nunca se genera.
export const ADVISORY_STATUS_NAMES: any = {
  pending_approval: 'Pendiente de aprobación',
  scheduled: 'Programada',
  rescheduled: 'Reprogramada',
  cancelled: 'Cancelada',
  finished: 'Finalizada',
};

export const ADVISORY_STATUS_BADGE_COLOR: any = {
  pending_approval: 'warning',
  // Distinto del celeste que usa el banner de "Cita agendada" en el detalle
  // — si comparten color, el estado y la fecha destacada se confunden a
  // simple vista (ver AdvisoryLeadDetailModal).
  scheduled: 'primary',
  rescheduled: 'warning',
  cancelled: 'danger',
  finished: 'success',
};
